export default __webpack_public_path__ + "static/media/2-3_image3.a7a1f2c0.png";